import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { emit } from "process";
import { CartActions } from "./cart.actions";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, EMPTY, filter, map, merge, of, switchMap, withLatestFrom } from "rxjs";
import { CartService } from "projects/shared/services/cart.service";
import { SelectRegionalCurrency } from "../../nav-regional/store/regional-setting.selectors";
import { SelectCart, SelectCartItems } from "./cart.selectors";
import { RegionalActions } from "../../nav-regional/store/regional-setting.actions";

@Injectable()
export class CartEffect {
  store = inject(Store);
  actions$ = inject(Actions);
  cartService = inject(CartService);
  currency$ = this.store.selectSignal(SelectRegionalCurrency);
  cartItems$ = this.store.selectSignal(SelectCartItems);
  cart$ = this.store.selectSignal(SelectCart);

  cartEffect$ = createEffect(() =>
    merge(
      this.actions$.pipe(ofType(CartActions.initializeCart)),
      this.actions$.pipe(ofType(RegionalActions.loadData)),
      this.actions$.pipe(ofType(RegionalActions.updateData)),
    ).pipe(
      switchMap(() => {
        const currency = this.currency$();
        const cart = this.cart$();

        const cartNotExists = !cart;
        const currencyMismatch = cart && cart.currency !== currency;

        if (!cartNotExists && !currencyMismatch) {
          return EMPTY;
        }

        return this.cartService.getCart(currency).pipe(
          switchMap(res => [
            CartActions.getCartData({ cart: res }),
            CartActions.getCartProducts({ items: res.products })
          ]),
          catchError((error) => of())
        );
      })
    )
  )

  itemEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActions.addItem, CartActions.updateCartItem, CartActions.mergeCartItems),
      switchMap((action) => {
        return this.cartService.addToCart(this.cartItems$()).pipe(
          switchMap(() => this.cartService.getCart(this.currency$())),
          switchMap(res => [
            CartActions.getCartData({ cart: res }),
            CartActions.getCartProducts({ items: res.products })
          ]),
          catchError((error) => of())
        );
      })
    )
  );

  removeItemEffect$ = createEffect(() => this.actions$.pipe(
    ofType(CartActions.removeItem),
    switchMap(() => this.cartService.addToCart(this.cartItems$()).pipe(
      switchMap(() => this.cartService.getCart(this.currency$())),
      switchMap(res => [
        CartActions.updateCart({ cart: res }),
        CartActions.getCartProducts({ items: res.products })
      ]),
      catchError((error) => [])
    ))
  ))


}